import React from "react";
import UseTitle from "../../Hooks/UseTitle";
import ballroom from "../../../Assets/Hompage/Restaurant/Restaurant (7).jpeg";
import ballroomCoverMobile from "../../../Assets/restaurant_mobile-05.jpg";
const MeetingAndEvents = () => {
  UseTitle("Conference & Ball room");
  return (
    <div className="bg-gray-100 pb-20">
      <div className="pt-16 md:pt-0 md:block hidden">
        <img className="w-full" src={ballroom} alt="Ball Room" />
      </div>
      <div className="pt-16 md:pt-0 block md:hidden">
        <img className="w-full" src={ballroomCoverMobile} alt="Ball Room" />
      </div>
      <div className="max-w-screen-xl mx-auto pb-10 md:px-0 px-8 py-10">
        <div className="mt-20">
          <div className="flex justify-center max-w-7xl mx-auto">
            <div className="nahid-title-designer">
              <h1
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
                className="text-[40px] font-bold tracking-wide"
              >
                Conference & Ball room
              </h1>

              <p className="text-[18px] mt-10 text-justify">
                Matir Maya Eco Resort is the ideal venue for Board meetings,
                Conference, Seminars, Workshops, Trainings, Parties, Cultural
                Programs and Executive retreats. We provide top notch technical
                support including MMP, projection screen, sound system with
                collar and wireless microphone for any kind of programs in
                conference room. Our highly experienced professionals are
                dedicated to meet your requirements and make your events
                successful.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingAndEvents;
